import { PrimaryHeaderNavGroup } from '../PrimaryHeaderNavGroup';
import { SecondaryHeaderNavGroup } from '../SecondaryHeaderNavGroup';
import { TertiaryHeaderNavGroup } from '../TertiaryHeaderNavGroup';

import styles from './HeaderDesktop.module.css';

export const HeaderDesktop = () => {
  return (
    <header className={styles.headerContainer} data-testid="header-desktop-v2">
			<PrimaryHeaderNavGroup />
			<SecondaryHeaderNavGroup />
			<TertiaryHeaderNavGroup />
		</header>);

};